export function getGeo() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve(null),
      { timeout: 8000, maximumAge: 60000 }
    );
  });
}

export function toApiParams(filters, geo) {
  const p = {};
  if (filters.category) p.category = filters.category;
  if (filters.tags?.length) p.tags = filters.tags.join(",");
  if (filters.price_max) p.price_max = filters.price_max;
  if (filters.open_now) p.open_now = true;
  if (filters.best_moment) p.best_moment = filters.best_moment;
  if (filters.q) p.q = filters.q;
  if (filters.good_first_visit) p.good_first_visit = true;
  if (filters.popular_students) p.popular_students = true;
  if (filters.ideal_evening) p.ideal_evening = true;
  if (filters.sort) p.sort = filters.sort;
  if (geo) { p.lat = geo.lat; p.lng = geo.lng; }
  return p;
}
